var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediumBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3114 17.2235V11.9457V10.9272V1.66797H4.59582V10.9272V11.9457V17.2235H3.4873V18.3346H16.5123V17.3161H15.3114V17.2235ZM9.39936 17.2235H7.92135V14.2606H9.49174V17.2235H9.39936ZM11.9859 17.2235H10.4155V14.2606H11.9859V17.2235ZM14.2953 17.2235H13.0944V13.1495H6.90521V17.2235H5.61195V11.9457H14.2953V17.2235ZM14.2953 10.8346H5.61195V2.59389H14.2953V10.8346ZM7.92135 5.0013H6.90521V3.89019H7.92135V5.0013ZM10.5079 5.0013H9.49174V3.89019H10.5079V5.0013ZM13.002 5.0013H11.9859V3.89019H13.002V5.0013ZM7.92135 7.31612H6.90521V6.20501H7.92135V7.31612ZM10.5079 7.31612H9.49174V6.20501H10.5079V7.31612ZM13.002 7.31612H11.9859V6.20501H13.002V7.31612ZM7.92135 9.63093H6.90521V8.51982H7.92135V9.63093ZM10.5079 9.63093H9.49174V8.51982H10.5079V9.63093ZM13.002 9.63093H11.9859V8.51982H13.002V9.63093Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumBusiness);
export default __webpack_public_path__ + "static/media/medium-business.dc3779c87b9a97694d6c25d92eeeb216.svg";
export { ForwardRef as ReactComponent };